import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

//constants
import { urlCommonAssets, title } from '../../Constants';

//hooks
import { useExcelData } from '../../hooks/useExcelData';

//types
import { Data } from '../../types/types';

//components
import Loading from '../common/Loading';
import HomeContent from './HomeContent';

const Home = () => {

    const { data, loading }: Data = useExcelData();

    return (
        <>
            <section className="mx-auto my-3 text-center cont-heading">
                <LazyLoadImage
                    alt="Tú decides"
                    effect="blur"
                    src={`${urlCommonAssets}img/elecciones-2022.png`}
                />
                <h1 className="mt-3 mb-0 title">{title}</h1>
            </section>
                {loading 
                    ? <Loading heightLoading="h-100" /> 
                    : <HomeContent data={data} />
            }
        </>            
    )
}

export default Home;